import { type ReactNode } from "react"
import { cn } from "~/utils/helpers"

type OverviewGridProps = {
  children: ReactNode
  className?: string
}

/**
 * Layout primitive — responsive 1/2/3-column card grid for OverviewPage.
 * Canonical intent: {@link ../intents.ts OVERVIEW_GRID_INTENT}.
 * Approved surface: design-system/APPROVED.md.
 */
const OverviewGrid = ({ children, className }: OverviewGridProps) => {
  return (
    <div className={cn("grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4", className)}>
      {children}
    </div>
  )
}

export default OverviewGrid
